var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import { useAtom, useAtomValue } from 'jotai';
import { Translate } from "../../../../../../I18N";
import { Button, Sidepanel } from "../../../../../Components/UI";

import { EntityFilter } from "./Filters";
import { filterSidepanelAtom, filterSidepanelStatusAtom } from "./filterSidepanelAtom";

const getFilterStatus = (
searchParams,
availableFilters) =>
{
  const result = {};

  if (availableFilters) {
    Object.entries(availableFilters).forEach(([key, value]) => {
      const selected =
      Object.hasOwn(searchParams, key) ||
      searchParams instanceof URLSearchParams && searchParams.getAll('status').includes(key);
      result[key] = { count: value, status: selected };
    });
  }
  delete result.total;
  return result;
};

const EntityFilterSidepanel = () => {
  const filterSidepanelStatus = useAtomValue(filterSidepanelStatusAtom);
  const [searchParams, setSearchParams] = useSearchParams();
  const [open, setOpen] = useAtom(filterSidepanelAtom);
  const [appliedFilters, setAppliedFilters] = useState(
    getFilterStatus(searchParams, filterSidepanelStatus)
  );

  useEffect(() => {
    const newFilters = getFilterStatus(
      searchParams,
      filterSidepanelStatus
    );
    if (newFilters !== appliedFilters) {
      setAppliedFilters(newFilters);
    }
    // avoids infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterSidepanelStatus]);

  const handleSubmit = () => {
    setSearchParams((prev) => {
      prev.delete('status');
      Object.entries(appliedFilters).forEach(([key, value]) => {
        if (value.status) {
          if (prev.get('status') === null) {
            prev.set('status', key);
          } else {
            prev.append('status', key);
          }
        }
      });
      return prev;
    });

    setOpen(false);
  };

  const clearFilters = () => {
    setAppliedFilters((prev) => {
      const keys = Object.keys(prev);
      keys.forEach((key) => {
        prev[key].status = false;
      });

      return _objectSpread({}, prev);
    });
  };

  return (/*#__PURE__*/
    _jsx(Sidepanel, {
      withOverlay: true,
      isOpen: open,
      closeSidepanelFunction: () => {
        setOpen(false);
      },
      title: /*#__PURE__*/
      _jsx("span", { className: "text-base font-semibold leading-6 text-gray-500 uppercase" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Filters")
      ) }, void 0, /*#__PURE__*/


    _jsx(Sidepanel.Body, {}, void 0, /*#__PURE__*/
    _jsx(EntityFilter, { filters: appliedFilters, setFilters: setAppliedFilters })
    ), /*#__PURE__*/
    _jsx(Sidepanel.Footer, { className: "px-4 py-3 border-t" }, void 0, /*#__PURE__*/
    _jsx("form", {
      className: "flex justify-end gap-2",
      onSubmit: (e) => {
        e.preventDefault();
        handleSubmit();
      } }, void 0, /*#__PURE__*/

    _jsx(Button, { size: "small", styling: "outline", onClick: clearFilters }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Clear All")
    ), /*#__PURE__*/
    _jsx(Button, { size: "small", type: "submit", color: "success" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Apply")
    )
    )
    )
    ));

};

export { EntityFilterSidepanel };